import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css';

function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <div className="error-page-content">
        <span className="error-page-code">404</span>
        <h1 className="error-page-title">{t('errors.notFoundTitle')}</h1>
        <p className="error-page-desc">{t('errors.notFoundDesc')}</p>
        <Link to="/" className="error-page-btn">{t('errors.goHome')}</Link>
      </div>
    </div>
  );
}

export default NotFound;
